interface MyFeeStatusBadgeProps {
  status: string;
  statusId: string | number;
}

/** statusId → semantik rang (Figma: success/warning/danger/neutral, tinted pill). */
export function MyFeeStatusBadge({ status, statusId }: MyFeeStatusBadgeProps) {
  const id = Number(statusId);
  const color =
    id === 4
      ? "var(--c-danger)" // Rad etildi
      : id === 3
        ? "var(--c-warning)" // Ko'rib chiqilmoqda
        : id === 7
          ? "var(--c-success)" // Faol / Yakunlangan
          : "var(--c-text-muted)";

  return (
    <span
      className="inline-flex items-center gap-1 rounded-full px-2.5 py-1 text-[11px] font-medium whitespace-nowrap"
      style={{ background: `color-mix(in srgb, ${color} 12%, transparent)`, color }}
    >
      <span className="size-1.5 shrink-0 rounded-full" style={{ background: color }} />
      {status}
    </span>
  );
}
